import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import RetirementCalculator from "@/components/tools/RetirementCalculator";
import ProtectionEstimator from "@/components/tools/ProtectionEstimator";
import CoverageSimulator from "@/components/tools/CoverageSimulator";
import { TOOLS } from "@/constants/testIds";

const Herramientas = () => {
  return (
    <main className="bg-white">
      <section className="pt-32 lg:pt-40 pb-12 bg-razmek-alt">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
          <div className="eyebrow">Herramientas</div>
          <h1 className="font-serif text-5xl md:text-6xl mt-6 leading-[1.02] text-razmek-dark">
            Visualiza tu
            <br />
            <span className="italic text-razmek-blue">futuro financiero</span>.
          </h1>
          <p className="mt-8 max-w-2xl font-sans text-lg leading-relaxed text-razmek-dark/70">
            Tres calculadoras pensadas para ayudarte a comprender, en cifras y
            con claridad, el orden de magnitud de tu estrategia patrimonial.
            Son herramientas de orientación: el diseño real lo construimos
            contigo en sesión.
          </p>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
          <Tabs defaultValue="retiro" className="w-full">
            <TabsList className="grid grid-cols-3 gap-2 bg-transparent p-0 h-auto border-b border-razmek rounded-none mb-12">
              <TabsTrigger
                value="retiro"
                data-testid={TOOLS.tabRetiro}
                className="rounded-none border-b-2 border-transparent data-[state=active]:border-razmek-gold data-[state=active]:bg-transparent data-[state=active]:text-razmek-blue font-sans tracking-[0.16em] uppercase text-[11px] py-4"
              >
                Retiro
              </TabsTrigger>
              <TabsTrigger
                value="proteccion"
                data-testid={TOOLS.tabProteccion}
                className="rounded-none border-b-2 border-transparent data-[state=active]:border-razmek-gold data-[state=active]:bg-transparent data-[state=active]:text-razmek-blue font-sans tracking-[0.16em] uppercase text-[11px] py-4"
              >
                Protección patrimonial
              </TabsTrigger>
              <TabsTrigger
                value="coberturas"
                data-testid={TOOLS.tabCoberturas}
                className="rounded-none border-b-2 border-transparent data-[state=active]:border-razmek-gold data-[state=active]:bg-transparent data-[state=active]:text-razmek-blue font-sans tracking-[0.16em] uppercase text-[11px] py-4"
              >
                Coberturas
              </TabsTrigger>
            </TabsList>

            <TabsContent value="retiro">
              <RetirementCalculator />
            </TabsContent>
            <TabsContent value="proteccion">
              <ProtectionEstimator />
            </TabsContent>
            <TabsContent value="coberturas">
              <CoverageSimulator />
            </TabsContent>
          </Tabs>
        </div>
      </section>
    </main>
  );
};

export default Herramientas;
